import React from "react";
import "../../css/KutiesLayout.css"; // Import CSS file for styling

// const faithfulCottage = [
//   ["Akhila 05", "Animitta 06", "Asanga 07", "Abhinandana 08", "Anumodhana 09", "Anidassana 10"],
//   ["Achala 04", "", "", "", "", "Anupassana 11"],
//   ["Asekha 03", "", "", "", "", "Asewana 12"],
//   ["Aneegha 02", "Aneja 01", "", "", "", "Abhiwandana 13", "Aasewitha 14"]
// ];

const faithfulCottage = [
    ["Akhila 05", "Achala 04", "Asekha 03","Aneegha 02"],
    ["Animitta 06", "", "", "Aneja 01"],
    ["Asanga 07", "", "",  ""],
    [ "Abhinandana 08", "", "", "",],
    ["Anumodhana 09", "", "", "Aasewitha 14",],
    [ "Anidassana 10", "Anupassana 11", "Asewana 12", "Abhiwandana 13",]

  ];
const otherCottages = {
  "Peaceful Cottage": ["Khanti 15", "Metta 16", "Nipaka 17", "Khema 18"],
  "Graceful Cottage": ["Nirodha 19", "Nirasha 20", "Sekha 21", "Wayama 22"],
  "Mindful Cottage": ["Nissarana 23", "Wiveka 24", "Amatha 25", "Nibbhuta 26"],
};

const KutiesLayout = () => {
  const handleClick = (name) => {
    if (name) alert(`You clicked on ${name}`);
  };

  return (
    <div className="container mt-6">
      
      <div className="faithful-cottage">
        <h2>Faithful Cottage</h2>
        <div className="faithful-grid">
          {faithfulCottage.map((row, rowIndex) => (
            <div key={rowIndex} className="row">
              {row.map((name, colIndex) => (
                <div
                  key={colIndex}
                  className={`kutie-box ${name ? "filled" : "empty"}`}
                  onClick={() => handleClick(name)}
                >
                  {name || ""}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
      {/* {Object.keys(otherCottages).map((cottage) => (
        <div key={cottage} className="cottage">
          <h2>{cottage}</h2>
          <div className="other-grid">
            {otherCottages[cottage].map((name, index) => (
              <div key={index} className="kutie-box filled" onClick={() => handleClick(name)}>
                {name}
              </div>
            ))}
          </div>
        </div>
      ))} */}
    </div>
  );
};

export default KutiesLayout;
